import React, { useState, useEffect } from "react";
import "./Slbpr.css";

const SlbprProjectPopup = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1800);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleLearnMore = () => {
    window.open("https://slbpr.com", "_blank");
  };

  if (!isVisible) return null;

  return (
    <div className="gp-popup-overlay" onClick={handleClose}>
      <div className="gp-popup-container" onClick={(e) => e.stopPropagation()}>
        {/* Animated Border Glow */}
        <div className="gp-border-glow"></div>

        {/* Close Button */}
        <button
          className="gp-close-btn"
          onClick={handleClose}
          aria-label="Close popup"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        {/* Hero Image Section */}
        <div className="gp-hero-section">
          <div className="parent">
            <img
              src="/images/slbpr-images/srilankan-image.png"
              alt="Sri Lankan flag"
              className="center-img"
            />
          </div>
          <div className="gp-hero-overlay"></div>
          <div className="gp-hero-content">
            <div className="gp-badge">
              <span className="gp-badge-icon">🏛️</span>
              <span>GOVERNMENT PROJECT · COMPLETED</span>
            </div>
            {/* <div className="gp-celebration-icon">🎉</div> */}
          </div>
        </div>

        {/* Main Content */}
        <div className="gp-content">
          <h2 className="gp-title">
            Project Successfully{" "}
            <span className="gp-highlight">Delivered!</span>
          </h2>

          <div className="gp-divider">
            <span className="gp-divider-line"></span>
            <span className="gp-divider-icon">✦</span>
            <span className="gp-divider-line"></span>
          </div>
          <div className="parent">
            <img
              src={"/images/slbpr-images/slbpr-logo.jpg"}
              alt={"slbpr"}
              height={80}
              width={80}
              // className="logo-img"
            />
          </div>

          <div className="gp-client-info">
            <p className="gp-subtitle">Sri Lanka High Commission for Delhi</p>
            <h3 className="gp-project-name">
              The Sri Lanka Buddhist Pilgrims' Rest (SLBPR)
            </h3>
          </div>

          <div className="gp-description-wrapper">
            <div className="gp-quote-mark">"</div>
            <p className="gp-description">
              We're proud to announce the successful completion of a prestigious
              government project. We've developed a comprehensive{" "}
              <strong>live booking portal</strong> with integrated features for
              accommodation management, reservation systems, and guest services.
            </p>
          </div>

          {/* Features Grid - Enhanced */}
          <div className="gp-features">
            <div className="gp-feature-card">
              <div className="gp-feature-icon-wrapper">
                <div className="gp-feature-icon">📅</div>
              </div>
              <div className="gp-feature-text">
                <h4>Live Booking System</h4>
                <p>Real-time availability & reservations</p>
              </div>
            </div>

            <div className="gp-feature-card">
              <div className="gp-feature-icon-wrapper">
                <div className="gp-feature-icon">🔒</div>
              </div>
              <div className="gp-feature-text">
                <h4>Government-Grade Security</h4>
                <p>Enterprise-level data protection</p>
              </div>
            </div>

            <div className="gp-feature-card">
              <div className="gp-feature-icon-wrapper">
                <div className="gp-feature-icon">🌐</div>
              </div>
              <div className="gp-feature-text">
                <h4>Multi-Language Support</h4>
                <p>English, Sinhala & Tamil</p>
              </div>
            </div>

            <div className="gp-feature-card">
              <div className="gp-feature-icon-wrapper">
                <div className="gp-feature-icon">📊</div>
              </div>
              <div className="gp-feature-text">
                <h4>Advanced Analytics</h4>
                <p>Insights & reporting dashboard</p>
              </div>
            </div>
          </div>

          {/* Stats Section */}
          <div className="gp-stats">
            <div className="gp-stat-item">
              <div className="gp-stat-number">50+</div>
              <div className="gp-stat-label">Rooms Managed</div>
            </div>
            <div className="gp-stat-divider"></div>
            <div className="gp-stat-item">
              <div className="gp-stat-number">24/7</div>
              <div className="gp-stat-label">Support System</div>
            </div>
            <div className="gp-stat-divider"></div>
            <div className="gp-stat-item">
              <div className="gp-stat-number">100%</div>
              <div className="gp-stat-label">Client Satisfaction</div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="gp-cta-buttons">
            <button className="gp-btn gp-btn-primary" onClick={handleLearnMore}>
              <span>Explore SLBPR.com</span>
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M7 17L17 7M17 7H7M17 7V17" />
              </svg>
            </button>
            <button className="gp-btn gp-btn-secondary" onClick={handleClose}>
              Maybe Later
            </button>
          </div>
          {/* Appreciation Letter PDF */}
          {/* <div className="gp-pdf-section">
            <h3 className="gp-pdf-title">Appreciation Letter</h3>

            <div className="gp-pdf-viewer">
              <iframe
                src="/pdfs/Appreciation Letter.pdf"
                title="SLBPR Appreciation Letter"
                width="100%"
                height="400px"
              />
            </div>

            <a
              href="/pdfs/slbpr-appreciation-letter.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="gp-download-btn"
            >
              View Full Letter
            </a>
          </div> */}
        </div>

        {/* Floating Particles */}
        {/* <div className="gp-particle gp-particle-1">✨</div> */}
        {/* <div className="gp-particle gp-particle-2">🎯</div> */}
        {/* <div className="gp-particle gp-particle-3">🏆</div> */}
        {/* <div className="gp-particle gp-particle-4">⭐</div> */}
      </div>
    </div>
  );
};

export default SlbprProjectPopup;
